/**
 * @file transfer-pricing.api.js
 * @module TransferPricingAPI
 * @description API wrapper for managing rates: CRUD, bulk actions and histories.
 * Methods return Axios promises created by axiosInstance(token).
 */

import { axiosInstance } from "./axios"

export const TransferPricingAPI = {
    /**
     * Get a transfer pricing quotation for a generic (non product-bound) request.
     * @param {Object} payload - Quotation request (e.g. origin, destination, dates, pax).
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to the quotation result.
     */
    getTransferPricingQuotation: (payload, token = "") => {
        return axiosInstance(token).post(`/transfer-pricing/quotation`, payload);
    },
    /**
     * Get a transfer pricing quotation scoped to a specific product.
     * @param {string} id - Product identifier.
     * @param {Object} payload - Quotation request (e.g. origin, destination, dates, pax).
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to the quotation result.
     */
    getTransferPricingProductQuotation: (id, payload, token = "") => {
        return axiosInstance(token).post(`/transfer-pricing/products/${id}/quotation`, payload);
    }
}